import { useI18n } from 'core/hooks/useI18n';
import { editNoiseEventClassification } from 'app/business-logic/services/noise-service/editNoiseEventClassification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigateToNoiseClassificationListing as useBackToListing } from '../noise-classifications-listing/useNavigateToNoiseClassificationListing';
import { QUERY_KEY } from 'app/business-logic/services/enums';

export const useEditNoiseClassification = () => {
  const { l10n } = useI18n('app/views/configuration/pages/noise', 'classifications.error');
  const backToListing = useBackToListing();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: editNoiseEventClassification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.noiseEventClassifications],
      });
      backToListing();
    },
    onError: (error, variables) => {
      console.error(error);
      if (window.confirm(l10n('tryAgain'))) mutate(variables);
    },
  });
  return {
    editNoiseClassification: mutate,
    isPending,
  };
};
